/* tslint:disable */
import {
  StockWarehouseLocation,
  Partner,
  Product,
  StockMove,
  StockLocation,
  Users,
  Company,
  HomogenizationOrderInLine,
  HomogenizationOrderOutLine,
  LotQualityAnalysis
} from '../index';

declare var Object: any;
export interface HomogenizationOrderInterface {
  "id"?: number;
  "name"?: string;
  "warehouse_location_id"?: number;
  "partner_id"?: number;
  "product_id"?: number;
  "in_line_ids"?: Array<any>;
  "in_move_ids"?: Array<any>;
  "out_line_ids"?: Array<any>;
  "out_move_ids"?: Array<any>;
  "location_id"?: number;
  "location_dest_id"?: number;
  "no_quality_location_id"?: number;
  "production_location_id"?: number;
  "date_planned_start"?: Date;
  "date_done"?: Date;
  "state"?: string;
  "user_id"?: number;
  "company_id"?: number;
  "analysis_ids"?: Array<any>;
  "quality_analysis_parent_id"?: number;
  warehouseLocation?: StockWarehouseLocation;
  partner?: Partner;
  product?: Product;
  inMoves?: StockMove[];
  outMoves?: StockMove[];
  location?: StockLocation;
  locationDest?: StockLocation;
  noQualityLocation?: StockLocation;
  productionLocation?: StockLocation;
  user?: Users;
  company?: Company;
  inLines?: HomogenizationOrderInLine[];
  outLines?: HomogenizationOrderOutLine[];
  analysis?: LotQualityAnalysis[];
  qualityAnalysisParent?: LotQualityAnalysis;
}

export class HomogenizationOrder implements HomogenizationOrderInterface {
  "id": number;
  "name": string;
  "warehouse_location_id": number;
  "partner_id": number;
  "product_id": number;
  "in_line_ids": Array<any>;
  "in_move_ids": Array<any>;
  "out_line_ids": Array<any>;
  "out_move_ids": Array<any>;
  "location_id": number;
  "location_dest_id": number;
  "no_quality_location_id": number;
  "production_location_id": number;
  "date_planned_start": Date;
  "date_done": Date;
  "state": string;
  "user_id": number;
  "company_id": number;
  "analysis_ids": Array<any>;
  "quality_analysis_parent_id": number;
  warehouseLocation: StockWarehouseLocation;
  partner: Partner;
  product: Product;
  inMoves: StockMove[];
  outMoves: StockMove[];
  location: StockLocation;
  locationDest: StockLocation;
  noQualityLocation: StockLocation;
  productionLocation: StockLocation;
  user: Users;
  company: Company;
  inLines: HomogenizationOrderInLine[];
  outLines: HomogenizationOrderOutLine[];
  analysis: LotQualityAnalysis[];
  qualityAnalysisParent: LotQualityAnalysis;
  constructor(data?: HomogenizationOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `HomogenizationOrder`.
   */
  public static getModelName() {
    return "HomogenizationOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of HomogenizationOrder for dynamic purposes.
  **/
  public static factory(data: HomogenizationOrderInterface): HomogenizationOrder{
    return new HomogenizationOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'HomogenizationOrder',
      plural: 'HomogenizationOrders',
      path: 'HomogenizationOrders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "in_line_ids": {
          name: 'in_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "in_move_ids": {
          name: 'in_move_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "out_line_ids": {
          name: 'out_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "out_move_ids": {
          name: 'out_move_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "location_dest_id": {
          name: 'location_dest_id',
          type: 'number'
        },
        "no_quality_location_id": {
          name: 'no_quality_location_id',
          type: 'number'
        },
        "production_location_id": {
          name: 'production_location_id',
          type: 'number'
        },
        "date_planned_start": {
          name: 'date_planned_start',
          type: 'Date'
        },
        "date_done": {
          name: 'date_done',
          type: 'Date'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "analysis_ids": {
          name: 'analysis_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "quality_analysis_parent_id": {
          name: 'quality_analysis_parent_id',
          type: 'number'
        },
      },
      relations: {
        warehouseLocation: {
          name: 'warehouseLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        inMoves: {
          name: 'inMoves',
          type: 'StockMove[]',
          model: 'StockMove',
          relationType: 'referencesMany',
                  keyFrom: 'in_move_ids',
          keyTo: 'id'
        },
        outMoves: {
          name: 'outMoves',
          type: 'StockMove[]',
          model: 'StockMove',
          relationType: 'referencesMany',
                  keyFrom: 'out_move_ids',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        locationDest: {
          name: 'locationDest',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_dest_id',
          keyTo: 'id'
        },
        noQualityLocation: {
          name: 'noQualityLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'no_quality_location_id',
          keyTo: 'id'
        },
        productionLocation: {
          name: 'productionLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'production_location_id',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'user_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        inLines: {
          name: 'inLines',
          type: 'HomogenizationOrderInLine[]',
          model: 'HomogenizationOrderInLine',
          relationType: 'referencesMany',
                  keyFrom: 'in_line_ids',
          keyTo: 'id'
        },
        outLines: {
          name: 'outLines',
          type: 'HomogenizationOrderOutLine[]',
          model: 'HomogenizationOrderOutLine',
          relationType: 'referencesMany',
                  keyFrom: 'out_line_ids',
          keyTo: 'id'
        },
        analysis: {
          name: 'analysis',
          type: 'LotQualityAnalysis[]',
          model: 'LotQualityAnalysis',
          relationType: 'referencesMany',
                  keyFrom: 'analysis_ids',
          keyTo: 'id'
        },
        qualityAnalysisParent: {
          name: 'qualityAnalysisParent',
          type: 'LotQualityAnalysis',
          model: 'LotQualityAnalysis',
          relationType: 'belongsTo',
                  keyFrom: 'quality_analysis_parent_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/HomogenizationOrder.ts